import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'landing-features',
    templateUrl: './landing-features.component.html',
    styleUrls: ['./landing-features.component.scss']
})
export class LandingFeaturesComponent implements OnInit {
    constructor() {
    }

    ngOnInit() {}


    ngAfterViewInit() {

    }
}
